import React, { FC } from 'react';
import { GenNavTile, UniversalLink } from '@/components';
import {
  TypeAccountNavTileFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import { TypeMyAccountPageTranslations } from '@/utils/translations/types/TypeMyAccountPageTranslations';
import {
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  buildPayloadUrl,
} from '@/utils/rudderstack';
import { getCtaTextStyles } from '@/components/utils';

export type PlayKitsTileProps = {
  t: TypeMyAccountPageTranslations;
  tile: TypeAccountNavTileFields;
};

const PlayKitsTile: FC<PlayKitsTileProps> = ({ tile }) => {
  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: buildPayloadUrl(tile.buttonLink?.fields as TypeLink_internalFields),
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.PLAY_KITS_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={
        <UniversalLink
          link={tile.buttonLink}
          classes={`w-fit underline font-bold ${getCtaTextStyles()}`}
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(PlayKitsTile);
